"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = pushToDataLayer;
const PageHelper_1 = __importDefault(require("@react/common/PageHelper/PageHelper"));
const GlobalDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GlobalDataLayer"));
function pushToDataLayer(dataLayerContents) {
    if (PageHelper_1.default.isLoggedInAdminRole() === false) {
        const dataLayer = new GlobalDataLayer_1.default();
        dataLayer.push(dataLayerContents);
    }
}
